import { NgModule } from '@angular/core';
import { BetonCmsComponents } from '@core/const';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { BetonOrderFormModule } from '../../components';
import { BetonOrderCmsFormComponent } from './beton-order-cms-form.component';

@NgModule({
  declarations: [BetonOrderCmsFormComponent],
  imports: [
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [BetonCmsComponents.RosaCMSBetonOrderComponent]: {
          component: BetonOrderCmsFormComponent,
        },
      },
    }),
    BetonOrderFormModule,
  ],
})
export class BetonOrderCmsFormModule {}
